<template>
  <v-dialog v-model="show" @click:outside="onClickOutside">
    <popup-layout height="95vh" @close="close">
      <div class="popup-container" v-if="item">
        <div class="popup-content">
          <div class="left-section">
            <h4 class="popup-title clearfix">Group Details</h4>
            <div class="item-image" v-if="itemImage">
              <img :src="itemImage" />
            </div>
            <div class="item-top">
              <h4 class="item-title">{{ item.title }}</h4>
              <div class="additional-tools">
                <div
                  class="icon clickable send-message"
                  @click="onClickSendMessage"
                >
                  <img :src="icons.newMessageIcon" />
                </div>
                <div
                  class="icon clickable external-link"
                  v-if="item.websiteUrl"
                >
                  <a
                    :href="item.websiteUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img :src="icons.externalLinkIcon" />
                  </a>
                </div>
              </div>
            </div>
            <item-attributes :item="item" />
            <div class="item-description" v-if="item.description">
              <perfect-scrollbar class="ps">
                {{ item.description }}
              </perfect-scrollbar>
            </div>
          </div>
          <div class="right-section">
            <div class="members-container" v-if="members && members.length > 0">
              <h4 class="popup-title">Members</h4>
              <div class="members-list">
                <MemberItem
                  v-for="(m, index) of members"
                  :key="index"
                  :item="m"
                />
              </div>
              <Pagination v-model="memberPage" @change="onMemberPageChange" color="var(--color-blue-sky)" />
            </div>
          </div>
        </div>
      </div>
    </popup-layout>
  </v-dialog>
</template>

<script>
import Pagination from "../Pagination.vue";
import MemberItem from "./MemberItem.vue";
import ItemAttributes from "./ItemAttributes.vue";
import PopupLayout from "../../layouts/PopupLayout.vue";
import newMessageIcon from "@/assets/images/icons/ew-icon_new-message.svg";
import externalLinkIcon from "@/assets/images/icons/ew-icon_external-link.svg";

export default {
  components: { PopupLayout, ItemAttributes, MemberItem, Pagination },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    groupId: {
      type: String,
      default: "",
    },
    memberLimit: {
      type: Number,
      default: 8,
    },
  },
  watch: {
    groupId(newValue) {
      if (newValue) {
        this.load();
        this.loadMembers();
      }
    },
    value(newValue) {
      this.show = newValue;
    },
  },
  computed: {
    itemImage() {
      if (!this.item) return "";

      return this.item.mainImageUrl || this.item.thumbnailUrl || "";
    },
  },
  mounted() {
    this.show = this.value;
    this.load();
    this.loadMembers();
  },
  data() {
    return {
      icons: {
        newMessageIcon,
        externalLinkIcon,
      },
      show: false,
      item: null,
      members: [],
      memberPage: 1,
    };
  },
  methods: {
    async load() {
      if (!this.groupId) return;

      this.item = await this.$repo.group.getGroupById(this.groupId);
    },
    async loadMembers() {
      if (!this.groupId) return;
      const { results } = await this.$repo.group.getGroupExperiences(
        this.groupId,
        this.memberLimit,
        this.memberPage
      );
      this.members = results;
    },
    close() {
      this.item = null;
      this.$emit("input", false);
      this.$emit("close");
    },
    onClickOutside() {
      this.close();
    },
    onClickSendMessage() {
      this.$emit("sendMessage");
    },
    onMemberPageChange() {
      this.loadMembers();
    },
  },
};
</script>

<style lang="scss" scoped>
.popup-container {
  padding: 0 6px 10px;

  .popup-title {
    font-size: 24px;
    margin: 0 0 20px;
    color: var(--color-blue-sky);
  }

  .item-image {
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .item-top {
    display: flex;
  }

  .additional-tools {
    display: flex;
    user-select: none;
  }

  .icon {
    width: 30px;
    height: auto;

    & + .icon {
      margin-left: 16px;
    }
  }

  .item-title {
    font-size: 18px;
    margin-right: 10px;
    flex: 1 1 auto;
  }

  .item-description {
    margin-top: 70px;
  }

  .members-list {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: 1fr;
    column-gap: 15px;
    row-gap: 15px;
  }

  @media screen and (min-width: $breakpoint-tablet) {
    .popup-content {
      display: flex;
      justify-content: space-between;
    }

    .left-section {
      width: 50%;
      justify-content: center;
      align-items: center;
      margin-right: 30px;
    }

    .right-section {
      flex: 1 1 auto;
    }

    .item-image {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 150px;
      height: 150px;
      float: left;
      margin-right: 40px;
    }

    .item-info {
      float: right;
    }

    .members-list {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}
</style>